import React from "react"
import PropTypes from "prop-types"
import {Box, LinearProgress, Stack, Typography} from "@mui/material"
import {clampProgress} from "./workflow-execution"

const WorkflowProgress = ({processed = 0, total = 0, percent, compact = false}) => {
    const safeTotal = Math.max(0, Number(total) || 0)
    const safeProcessed = Math.min(Math.max(0, Number(processed) || 0), safeTotal || Number(processed) || 0)
    const calculated = safeTotal > 0 ? safeProcessed * 100 / safeTotal : 0
    const value = clampProgress(percent ?? calculated)

    return (
        <Stack spacing={0.6} sx={{width: "100%"}}>
            <Box sx={{display: "flex", justifyContent: "space-between", gap: 1}}>
                <Typography variant="caption" color="primary.white70">
                    {safeProcessed}/{safeTotal}
                </Typography>
                <Typography variant="caption" color="common.white">
                    {value.toFixed(value % 1 === 0 ? 0 : 1)}%
                </Typography>
            </Box>
            <LinearProgress
                aria-label="Progresso da execução"
                variant="determinate"
                value={value}
                sx={{
                    height: compact ? 5 : 8,
                    borderRadius: 1,
                    backgroundColor: "primary.white10",
                    "& .MuiLinearProgress-bar": {backgroundColor: "primary.main2"},
                }}
            />
        </Stack>
    )
}

WorkflowProgress.propTypes = {
    processed: PropTypes.number,
    total: PropTypes.number,
    percent: PropTypes.number,
    compact: PropTypes.bool,
}

export default WorkflowProgress
